import { Input, InputFooter } from "@amzn/stencil-react-components/form";
import {Row, Spacer} from "@amzn/stencil-react-components/layout";
import { Label } from "@amzn/stencil-react-components/text";
import React from "react";
import { useAppDispatch, useAppSelector } from "src/state/hooks";
import { updateEventName } from "src/state/slice/EventModelSlice";
import "src/components/commonStyles.scss";
import {IconWithTooltip} from "src/components/helperComponents/IconWithTooltip";

const STRINGS_DISPLAYED = {
  event_name_label: "Event Name",
  event_name_placeholder: " A nice name for your event",
  event_name_tooltip: "Event name once saved cannot be edited. Please use a valid and unique event name",
  invalid_chars_existing_message: "Invalid Chars in event Name. Enter event name without these chars: / # % + \\ . ? ",
  event_model_already_exist_message: "An Event model already exists with this name. Please try again with a different name."

}

type props = {
  disabled: boolean;
  isEventModelExist: boolean;
  isValid: boolean;
}

/**
 * Renders the components to let users define their event model name.
 */
export const DefineEventName = ({ disabled, isEventModelExist, isValid }: props) => {

  const dispatch = useAppDispatch();
  const eventModelState = useAppSelector(({eventModel}) => eventModel);

  return <Row
    alignItems={"center"}
    justifyContent={"space-between"}
    width={"fit-content"}
  >
    <Label
      fontSize={"20px"}
      fontWeight={"bold"}
      htmlFor={"event-name-input"}
      className={"width_200_px"}
    >
      {STRINGS_DISPLAYED.event_name_label}
    </Label>
    <Input
      id={"event-name-input"}
      placeholder={STRINGS_DISPLAYED.event_name_placeholder}
      width={"400px"}
      onChange={(e) => {
        dispatch(updateEventName(e.target.value));
      }}
      value={eventModelState.eventName}
      disabled={disabled}
      error={!isValid || isEventModelExist}
    />
    <Spacer width={"4px"}/>
    {
        !disabled &&
        <IconWithTooltip
            tooltipText={STRINGS_DISPLAYED.event_name_tooltip}
            color={"primary70"}
        />
    }
    {(!isValid || isEventModelExist) && <InputFooter id="input-footer-1" className={"width_200_px"} error>
      {
        !isValid ? STRINGS_DISPLAYED.invalid_chars_existing_message :
        STRINGS_DISPLAYED.event_model_already_exist_message
      }
    </InputFooter>
    }
  </Row>
}
